(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mbc-core"), require("mbc-flag"));
	else if(typeof define === 'function' && define.amd)
		define(["mbc-core", "mbc-flag"], factory);
	else if(typeof exports === 'object')
		exports["mbc-donut"] = factory(require("mbc-core"), require("mbc-flag"));
	else
		root["mbc-donut"] = factory(root["mbc-core"], root["mbc-flag"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 117);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(18);


/***/ }),

/***/ 18:
/***/ (function(module, exports, __webpack_require__) {

"use strict";



__webpack_require__(98);

var _donutChart = __webpack_require__(56);

var _donutChart2 = _interopRequireDefault(_donutChart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _donutChart2.default;

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Core = __webpack_require__(0);
var Utils = Core.Utils;
var nullify = Utils.NaNtoNull;

function DataMethods() {}
/**
 * To modify the data
 * @param {Array} arr of data objects
 */
DataMethods.prototype.setData = function (arr) {
    var cloned = [].concat(arr);
    this.set("donutData", this.addDataAttributes(arr));
    this.set("sortedData", this.addDataAttributes(cloned, true));
    this.set("longestLabel", this.getLongestText(arr));
};
/**
 * To add attributes to each data object
 * @param {Array} arr of data objecs
 */
DataMethods.prototype.addDataAttributes = function (arr) {
    var sorted = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var total = 0;
    var _this = this;
    var format = this.tickFormat(function (d) {
        var formatted = _this.tickFormat(_this.get("format"))(d);
        return Utils.string.convertDashToEnDash(formatted);
    });

    arr.forEach(function (obj) {
        total += nullify(_this.getSingleSliceValue(obj));
    });

    // calcluating the percentage value
    arr.forEach(function (obj) {
        obj.percentage = format(nullify(_this.getSingleSliceValue(obj)) / total * 100);
    });

    // calculating the donut slice angle
    arr.forEach(function (obj) {
        obj.angle = (nullify(_this.getSingleSliceValue(obj)) * 360 / total).toFixed(2);
    });

    if (sorted) {
        arr.sort(function (a, b) {
            return b.percentage - a.percentage;
        });
    }

    return arr;
};
/**
 * The default path to the data values
 * @param  {Object} obj
 * @return {Number} data value for each donut slice
 */
DataMethods.prototype.getSingleSliceValue = function (obj) {
    return obj.count;
};

module.exports = DataMethods;

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function LegendMixin() {}
/**
 * To construct the legend
 */
LegendMixin.prototype.drawLegend = function () {

    var legendContainer = this.get("donutLegendContainer");
    var container = d3.select(legendContainer);
    var legendRectWidth = this.get("legendRectWidth");
    var legendSpacing = this.get("legendSpacing");
    var padding = this.get("legendPadding");
    var sortData = this.get("sortData");
    var width = this.get("legendLabelMaxWidth");
    var _this = this;
    var legendOrient = this.get("legendOrient");

    container.classed(this.get("id"), true);
    container.style("text-align", legendOrient);

    var data = sortData ? this.get("sortedData") : this.get("donutData");

    var legendCanvas = container.append("svg").classed("donut-legend-canvas", true).style("width", "100%").style("height", "100%").style("padding-top", 25);

    var legend = legendCanvas.selectAll("g").data(data).enter().append("g").attr("class", "legend");

    legend.append("circle").classed("legend-circle", true).attr("cx", 10).attr("cy", 10).attr("r", 4).attr("stroke", function (d, i) {
        return this.color(i);
    }.bind(this)).attr("transform", function (d, i) {
        return "translate(0, " + (i + 1) * 20 + ")";
    });

    legend.append("circle").classed("legend-circle-layered", true).attr("cx", 10).attr("cy", 10).attr("r", 3).attr("stroke", function (d, i) {
        return this.color(i);
    }.bind(this)).attr("transform", function (d, i) {
        return "translate(0, " + (i + 1) * 20 + ")";
    });

    legend.append("text").classed("legend-text", true).classed("legend-label", true).classed("legend-label-name", true).attr("x", legendRectWidth + legendSpacing).attr("y", legendRectWidth - legendSpacing).text(function (d) {
        return d.label;
    }).attr("transform", function (d, i) {
        return "translate(0 , " + (i + 1) * 20 + ")";
    }).each(function () {
        _this.wrap.call(this, width);
    });

    legend.append("text").classed("legend-text", true).classed("legend-label", true).classed("legend-value", true).attr("x", legendRectWidth + legendSpacing + width + padding).attr("y", legendRectWidth - legendSpacing).attr("text-anchor", "end").text(function (d) {
        return d.percentage;
    }).attr("transform", function (d, i) {
        return "translate(" + 0 + "," + (i + 1) * 20 + ")";
    });

    var longestLegendWidth = this.getLongestLegendGroupWidth();
    legendCanvas.style("width", longestLegendWidth + 20);
};
/**
 * To get the longest legend group item
 */
LegendMixin.prototype.getLongestLegendGroupWidth = function () {
    var longest = 0;
    var allItems = d3.selectAll(".legend")[0];

    for (var i = 0; i < allItems.length; i++) {
        var width = allItems[i].getBBox().width;
        longest = width > longest ? width : longest;
    }

    return longest;
};
/**
 * To get the longest legend text label
 */
LegendMixin.prototype.getLongestSVGTextElement = function () {
    var allText = document.querySelectorAll(".legend-text");
    var longest = 0;
    var n = allText.length;

    for (var i = 0; n < i; i++) {
        var w = allText[i].getBBox().width;
        if (w > longest) longest = w;
    }

    return longest;
};

/**
 * To add the legend title & configure legend alignment with chart;
 */
LegendMixin.prototype.drawLegendTitle = function () {
    var legendContainer = this.get("donutLegendContainer");
    var container = d3.select(legendContainer);
    var legendCanvas = container.select(".donut-legend-canvas");
    var legendRectWidth = this.get("legendRectWidth");
    var legendSpacing = this.get("legendSpacing");

    legendCanvas.append("text").classed("legend-text", true).classed("legend-title", true).attr("x", legendRectWidth + legendSpacing).attr("y", legendRectWidth - legendSpacing).attr("text-anchor", "start").text(this.get("legendHeader")).attr("transform", function () {
        return "translate(0, 0)";
    });
};

/**
 * To draw the legend
 */
LegendMixin.prototype.renderLegend = function () {
    if (this.get("showLegend")) {
        this.drawLegend();
        this.drawLegendTitle();
    }
};
/**
 * To get longest legend label text svg length
 */
LegendMixin.prototype.getLongestText = function (arr) {

    var max = 0;

    for (var i = 0; i < arr.length; i++) {
        var l = arr[i].label.length;
        if (l > max) max = l;
    }

    return max;
};
/**
 * To truncate legend label text svgs
 */
LegendMixin.prototype.wrap = function (width) {
    var _this = d3.select(this);
    var textLength = _this.node().getComputedTextLength();
    var text = _this.text();

    while (textLength > width && text.length > 0) {
        text = text.slice(0, -1);
        _this.text(text + " ...");
        textLength = _this.node().getComputedTextLength();
    }
};

module.exports = LegendMixin;

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ToolTip = __webpack_require__(1);

function ToolTipMixin() {}
/**
 * To configure the tool tip template function
 * Always set the template function to the "template" key;
 * The template div must be given the "tooltip-inner" class;
 * The template function must accept "d" as a parameter;
 * E.g., this.set("toolTipTemplate", {template: function(d){....}})
 * @type {Object}
 */
ToolTipMixin.prototype.toolTipTemplate = function (d) {

    return "<div class=\"tooltip-inner tooltip-flag\">\n                <div class=\"tooltip-body\">\n                    <div class=\"cell\">\n                        <div class=\"tip-cell-name\">" + d.data.label + "</div>\n                        <div class=\"tip-cell-data\">" + d.data.percentage + "%</div>\n                    </div>\n                </div>\n            </div>";
};

/**
 * To bind the tooltip to the donut chart slices
 */
ToolTipMixin.prototype.addToolTip = function () {

    var t = this.toolTipTemplate.bind(this);

    var tooltip = ToolTip({
        namespace: this.get("id")
    }).template(t);

    var canvas = this.get("canvas"),
        layer = canvas.layer("donut-chart-layer"),
        svg = layer.selectAll("path");

    svg.call(tooltip.bind());

    this.set("tooltipInfo", tooltip);
};

ToolTipMixin.prototype.changeToolTipDirection = function (obj) {

    var tooltip = this.get("tooltipInfo"),
        radius = this.get("donutRadius");

    var tooFarRight, tooFarLeft, tooHigh;

    tooFarRight = obj.tooltip && obj.mouse[0] >= radius / 2 - obj.tooltip.width;
    tooFarLeft = obj.tooltip && obj.mouse[0] < radius / 2 - obj.tooltip.width;
    tooHigh = obj.tooltip && obj.mouse[1] < 0;

    if (tooFarRight && tooHigh) {
        tooltip.hide();
        this.set("tooltipHidden", true);
        this.set("direction", "bottom-left");
        return;
    }

    if (tooFarLeft && tooHigh) {
        tooltip.hide();
        this.set("tooltipHidden", true);
        this.set("direction", "bottom-right");
        return;
    }

    if (tooFarRight && !tooHigh) {
        tooltip.hide();
        this.set("tooltipHidden", true);
        this.set("direction", "top-left");
        return;
    }

    if (tooFarLeft && !tooHigh) {
        tooltip.hide();
        this.set("tooltipHidden", true);
        this.set("direction", "top-right");
        return;
    }

    return;
};

ToolTipMixin.prototype.renderToolTip = function () {
    if (this.get("showToolTip")) {
        this.addToolTip();
    }
};

module.exports = ToolTipMixin;

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Core = __webpack_require__(0);
var ToolTipMixin = __webpack_require__(55);
var LegendMixin = __webpack_require__(54);
var DataMethods = __webpack_require__(53);
var Chart = Core.Chart;
var Utils = Core.Utils;
var nullify = Utils.object.NaNtoNull;
var mds_constants = Utils.colors.mds_constants;

/**
 * To create a donut chart class, an extension of the Chart Class
 *
 * @class
 * @extends Chart
 */
var Donut = Chart.extend(LegendMixin, ToolTipMixin, DataMethods,
/**
 *  @Donut
 **/
{
    // Default chart attributes
    /*** @type {String}*/
    backgroundColor: mds_constants["color"].white,
    /*** @type {Boolean}*/
    checkTooltipDirection: true,
    /*** @type {String}*/
    id: "mbc-donut-chart",
    margins: { top: 0, right: 0, bottom: 0, left: 0 },
    /***
     * @type {String}
     * an id or class name for the donut-chart legend must be passed in upon instantiating the chart
     * e.g, var donut = new DonutChart({"donutLegendContainer": "#dlc"});
     * if a container is not indicated via the `donutLegendContainer` property, the chart will not render a legend
     */
    donutLegendContainer: null,
    /*** @type {String}*/
    format: ",.2f",
    /*** @type {Number}*/
    legendLabelMaxWidth: 100,
    /*** @type {Number}*/
    legendRectWidth: 18,
    /*** @type {Number}*/
    legendWidth: 200,
    /*** @type {Number}*/
    legendSpacing: 4,
    /*** @type {Number}*/
    legendPadding: 50,
    /*** @type {String}*/
    legendHeader: "Asset Class %",
    /*** @type {Boolean}*/
    showLegend: true,
    /*** @type {String}*/
    legendOrient: "left",
    /*** @type {Number}*/
    maxWidthLegend: 140,
    /*** @type {Number}*/
    outerWidthBreakPoint: 400,
    /*** @type {Number}*/
    sliceTextSize: 18,
    /*** @type {String}*/
    sliceFontColor: mds_constants["color"].white,
    /*** @type {Boolean}*/
    showBorder: false,
    /*** @type {Boolean}*/
    showToolTip: true,
    /*** @type {Boolean}*/
    sortData: false,
    beforeDraw: function beforeDraw() {
        if (!this.get("donutLegendContainer")) this.set("showLegend", false);
        this.changeBackgroundColor(this.get("backgroundColor"));
    },
    /**
    * To render donut chart, legend and tooltip
    */
    draw: function draw() {

        this.removeLayer();
        this.setDimensions();
        this.buildDonut();
        this.renderToolTip();
        this.renderLegend();
    },
    /**
     * To set the donut chart dimensions
     */
    setDimensions: function setDimensions() {
        var canvas = this.get("canvas");
        var w = canvas.width();
        var h = canvas.height();
        var dW = Math.min(w, h) / 2 * 0.45;

        this.set("width", w);
        this.set("height", h);
        this.set("donutWidth", dW);
    },
    /**
     * To construct the donut
     */
    buildDonut: function buildDonut() {

        var canvas = this.get("canvas");
        var layer = canvas.layer("donut-chart-layer");
        var width = this.get("width");
        var height = this.get("height");
        var donutWidth = this.get("donutWidth");
        var radius = Math.min(width, height) / 2;
        var sortData = this.get("sortData");
        var _this = this;
        var showBorder = this.get("showBorder");
        var backgroundColor = this.get("backgroundColor");

        this.set("donutRadius", radius);

        var color = d3.scale.ordinal().range(this.get("colors"));
        var data = sortData ? this.get("sortedData") : this.get("donutData");

        var svg = layer.attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

        var arc = d3.svg.arc().innerRadius(donutWidth).outerRadius(radius);

        var pie = d3.layout.pie().value(function (d) {
            return nullify(_this.getSingleSliceValue(d));
        }).sort(null);

        svg.selectAll("path").data(pie(data)).enter().append("path").classed("donut-path", true).attr("d", arc).attr("fill", function (d, i) {
            return color(i);
        }).attr("stroke", function () {
            return showBorder ? backgroundColor : null;
        }).attr("stroke-width", function () {
            return showBorder ? "1px" : null;
        }).on("mousemove", function (d) {
            var obj = {};
            obj.tooltip = _this.get("tooltipInfo")._clientRect;
            obj.mouse = d3.mouse(this);
            obj.canvasWidth = canvas.width();
            obj.canvasHeight = canvas.height();

            if (_this.get("checkTooltipDirection")) {
                _this.changeToolTipDirection(obj);
            }
            if (_this.get("tooltipHidden")) {
                _this.get("tooltipInfo").show(d, {
                    position: _this.get("direction"),
                    namespace: _this.get("id")
                });
                _this.set("tooltipHidden", false);
            }
        });
    },
    /**
     * To remove donut layer in order to rebuild based on legend size
     */
    removeLayer: function removeLayer() {

        var canvas = this.get("canvas");
        var layer = canvas.layer("donut-chart-layer");
        var legend = d3.select(this.get("donutLegendContainer"));
        var legendLayer = legend.select(".donut-legend-canvas");

        if (layer) layer.remove();
        if (legendLayer) legendLayer.remove();
    },
    /**
     * To set the background color of the chart container
     */
    changeBackgroundColor: function changeBackgroundColor(color) {
        var container = this.get("selection");
        container.style("background-color", function () {
            return color;
        });
    }
});

module.exports = Donut;

/***/ }),

/***/ 98:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

/******/ });
});